import React, { useState } from "react";
import Modal from "../../common/components/Modal";
import useSubscribers from "../../common/hooks/pages/useSubscribers";
import { usePopup } from "../../common/contexts/PopupContext";
import Loading from "../../common/components/Loading";

function UploadForm({ open, setOpen, title, onSuccess }) {
  const { uploadSubscriber } = useSubscribers();
  const { toast } = usePopup();
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    try {
      if (!file) {
        setError("File is Required");
        return;
      }

      const fileName = file.name;
      const fileExtension = fileName.split(".").pop().toLowerCase();
      if (fileExtension !== "csv") {
        setError("Only CSV files are allowed");
        return;
      }

      setIsLoading(true);

      const formData = new FormData();
      formData.append("file", file);

      const response = await uploadSubscriber(formData);

      const { message } = response?.data || {};
      if (onSuccess) {
        onSuccess();
      }
      toast(message, "success");
      setOpen(false);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Failed to upload file. Please try again later.";
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title={title || "Upload Subscriber"} open={open} setOpen={setOpen}>
      <div className={`my-4`}>
        <div className="pb-1 text-gray-800">File</div>
        <input
          type="file"
          accept=".csv"
          onChange={handleFileChange}
          className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2  transition ease-in-out delay-150 w-full
          }`}
          required
        />
        {error && <div className="pt-1.5 text-red-600 text-sm">{error}</div>}
        <div className="pb-1 text-gray-800">
          <a class="back_link underline" href="SubscribersFormat.csv" download>
            Click here to download the file format
          </a>
        </div>
        <br />
        <button
          type="button"
          onClick={handleUpload}
          className={`rounded-md common_bg text-white w-full px-4 py-2 nav_link-500 transition ease-in-out duration-300 ${
            isLoading ? "opacity-70 cursor-not-allowed" : ""
          }`}
          disabled={isLoading}
        >
          {isLoading ? <Loading /> : "Submit"}
        </button>
      </div>
    </Modal>
  );
}

export default UploadForm;
